import mapValues from 'lodash/mapValues';

const colors = ['green', 'blue', 'accent', 'yellow', 'red', 'purple'];

export const getNextTagColor = (tags: Array<{ color?: string }>) => {
  const colorCounts: { [color: string]: number } = colors.reduce(
    (acc, color) => ({ ...acc, [color]: 0 }),
    {},
  );
  tags.forEach((tag: { color?: string }) => {
    if (!tag.color) {
      return;
    }
    if (!colorCounts[tag.color]) {
      colorCounts[tag.color] = 1;
    }
    colorCounts[tag.color]++;
  });

  let minVal = 0;
  let minColor = '';
  mapValues(colorCounts, (val, key) => {
    if (!minColor) {
      minColor = key;
      minVal = val;
      return;
    }
    if (val < minVal) {
      minVal = val;
      minColor = key;
    }
  });

  return minColor;
};
